module.exports = __webpack_public_path__ + "img/hubspot.90f8febc.png";